import { render, staticRenderFns } from "./StudentsReports.vue?vue&type=template&id=a66c551c&scoped=true"
import script from "./StudentsReports.vue?vue&type=script&lang=js"
export * from "./StudentsReports.vue?vue&type=script&lang=js"
import style0 from "./StudentsReports.vue?vue&type=style&index=0&id=a66c551c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66c551c",
  null
  
)

export default component.exports